import React from "react";
import Swal from "sweetalert2";


const images = import.meta.glob(
  "/src/assets/img/**/*.{png,jpg,jpeg,svg,avif}",
  { eager: true }
);

export function getViteImage(filename, fallback = "post1-1170x558.jpeg") {
  if (!filename) return fallback;

  // build the exact key Vite expects
  const key = `/src/assets/img/${filename}`;

  return images[key]?.default || fallback;
}

// SWAL POPUP
const baseToast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  background:"#1d1d1d",
  color:"#fff",
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  }
});

export const showError = (msg) => {
  baseToast.fire({
    icon: "error",
    title: msg,
    iconColor:"#ff810e"
  });
};

export const showSuccess = (msg) => {
  baseToast.fire({
    icon: "success",
    title: msg,
    iconColor:"#ff810e"
  });
};

export const showInfo = (msg) => {
  baseToast.fire({
    icon: "info",
    iconColor:"#ff810e",
    title: msg
  });
};